// export type AuthenticatedContext = {
// 	authnStatus: "authenticated";
// 	/**
// 	 * The Moment definition of a User. If for some reason you need the Auth0
// 	 * view of a user, it can be found as _Auth0User.
// 	 */
// 	user: User;
// 	_Auth0User?: Auth0User;
// };
import { z } from "zod/v4";

export const UserSchema = z
	.object({
		name: z.string().optional(),
		given_name: z.string().optional(),
		family_name: z.string().optional(),
		middle_name: z.string().optional(),
		nickname: z.string().optional(),
		preferred_username: z.string().optional(),
		profile: z.string().optional(),
		picture: z.string().optional(),
		website: z.string().optional(),
		email: z.string().optional(),
		email_verified: z.boolean().optional(),
		gender: z.string().optional(),
		birthdate: z.string().optional(),
		zoneinfo: z.string().optional(),
		locale: z.string().optional(),
		phone_number: z.string().optional(),
		phone_number_verified: z.boolean().optional(),
		address: z.string().optional(),
		updated_at: z.string().optional(),
		sub: z.string().optional(),
	})
	.catchall(z.any()); // handles the [key: string]: any part

export const AuthenticatedContextSchema = z.object({
	authnStatus: z.enum(["authenticated", "unauthenticated", "loading"]).default("unauthenticated"),
	user: UserSchema.optional(),
	_Auth0User: z.any().optional(),
	token: z.string().optional(),
});

export type AuthenticatedContext = z.infer<typeof AuthenticatedContextSchema>;
export type User = z.infer<typeof UserSchema>;
